export enum GameRatings {
  'Adult' = 'adult',
  'Family' = 'family',
  'Standard' = 'standard',
}
